import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

// const owners = () => import( /* webpackChunkName: "owners" */ './views/owners.vue');
// const realestate = () => import( /* webpackChunkName: "realestate" */ './views/realestate.vue');
// const purchase = () => import( /* webpackChunkName: "purchase" */ './views/purchase.vue');
const news = () => import( /* webpackChunkName: "news" */ './views/news.vue');
const newsCard = () => import( /* webpackChunkName: "news" */ '@/components/news/news-card.vue');
const contacts = () => import( /* webpackChunkName: "contacts" */ './views/contacts.vue');
const flatsCRM = () => import( /* webpackChunkName: "flats-crm" */ '@/components/flats-crm/flats-crm-page.vue');
const flatsCRMcard = () => import( /* webpackChunkName: "flats-crm-card" */ '@/components/flats-crm/flats-crm-card.vue');
const flatsCrmViewingHistory = () => import( /* webpackChunkName: "flats-crm-viewing-history" */ '@/components/flats-crm/flats-crm-viewing-history-page.vue');
const favoriteFlats = () => import( /* webpackChunkName: "flats-crm-favorite" */ '@/components/flats-crm/flats-crm-favorite.vue');
const home = () => import( /* webpackChunkName: "home" */ './views/home.vue');
const about = () => import( /* webpackChunkName: "about" */ './views/about.vue');
const privacy = () => import( /* webpackChunkName: "privacy" */ './views/privacy.vue');
const quality = () => import( /* webpackChunkName: "quality" */ './views/quality.vue');

const newOwners = () => import( /* webpackChunkName: "newOwners" */ './views/new-owners.vue');
const commerceSales = () => import( /* webpackChunkName: "commerce" */ './views/commerce-sales.vue');
const onlineBoocking = () => import( /* webpackChunkName: "online-boocking" */ './views/online-boocking.vue');
const seismicSafety = () => import( /* webpackChunkName: "seismic-safety" */ './views/seismic-safety.vue');
const awards = () => import( /* webpackChunkName: "awards" */ './views/awards.vue');
const answers = () => import( /* webpackChunkName: "answers" */ './views/answers.vue');


const actions = () => import( /* webpackChunkName: "actions" */ './views/actions.vue');
const actionCard = () => import( /* webpackChunkName: "actions" */ '@/components/actions/action-card.vue');
const sales = () => import( /* webpackChunkName: "sales" */ './views/sales.vue');
const salesCardPromo = () => import( /* webpackChunkName: "sale-card-promo" */ '@/components/sales/sale-card-promo.vue');
const projects = () => import( /* webpackChunkName: "projects" */ './views/projects.vue');
const projectCard = () => import( /* webpackChunkName: "projectCard" */ '@/components/projects/project-card.vue');
// const salesApp = () => import( /* webpackChunkName: "sales" */ '@/components/sales/sales-app.vue');
// const salesCardFlats = () => import( /* webpackChunkName: "sales" */ '@/components/sale-card/sale-card-flats.vue');
const SalesMap = () => import( /* webpackChunkName: "sales" */ './views/sales-map.vue');
const bazisClub = () => import( /* webpackChunkName: "bazis-club" */ './views/bazis-club.vue');
const bazisClubCard = () => import( /* webpackChunkName: "bazis-club" */ '@/components/bazis-club/bazis-club-card.vue');
const howToBy = () => import( /* webpackChunkName: "how-to-by" */ './views/how-to-by.vue');
const hypothec = () => import( /* webpackChunkName: "hypothec" */ './views/hypothec.vue');
const purchase = () => import( /* webpackChunkName: "purchase" */ './views/purchase.vue');
const hypothecCalculator = () => import( /* webpackChunkName: "hypothec-calculator" */ './views/hypothec-calculator-page.vue');
const bazisFinance = () => import( /* webpackChunkName: "bazis-finance" */ './views/bazis-finance.vue');
const favorite = () => import( /* webpackChunkName: "favorite" */ './views/favorite.vue');
const favoriteProjects = () => import( /* webpackChunkName: "favorite" */ '@/components/favorite/favorite-projects.vue');
const compare = () => import( /* webpackChunkName: "compare" */ './views/compare.vue');
const NotFound = () => import( /* webpackChunkName: "notFound" */ './views/404.vue');
const error = () => import( /* webpackChunkName: "error" */ './views/error.vue');
const howToTake = () => import( /* webpackChunkName: "how-to-take" */ './views/how-to-take.vue');
const video = () => import( /* webpackChunkName: "video" */ './views/video.vue');
const video_safety = () => import( /* webpackChunkName: "video" */ './views/video-safety.vue');
const online = () => import( /* webpackChunkName: "online" */ './views/online.vue');
const ENPF = () => import( /* webpackChunkName: "enpf" */ './views/enpf.vue');
// test pages
// const test_api_crm = () => import( /* webpackChunkName: "test_api_crm" */ './views/test_api_crm.vue');

Vue.use(Router)


const router = new Router({
	mode: 'history',
	hash: false,
	scrollBehavior (to, from, savedPosition) {
		// console.log(from ,'FFFFFF');
		// console.log(to, 'TTTTT');
		// if (savedPosition) 
		// else
		// return new Promise((resolve, reject) => {
		// 	resolve({ x: 0, y: 0 })
		// })
		return new Promise((resolve, reject) => {
		// setTimeout(() => {
			if (to.hash) {
				console.log(to.hash, 'adasdasd')
				return resolve({ 
					selector: to.hash,
					offset: { x: 0, y: 75 }
				});
			} else if (savedPosition) {
				// console.log(savedPosition, 'adasdasdas')
				return resolve(savedPosition);
			} else {
				// console.log('3')
				// return { x: 0, y: 0 };
				resolve(document.getElementById("app").scrollIntoView({ behavior: "instant" }));
				// resolve(document.getElementById("app").scrollIntoView({ behavior: "smooth" }));
			} 
		// }, 1200);
		});
		// // if (to.meta.parent != 'sale-card') {
		// return new Promise((resolve, reject) => {
		// 	// setTimeout(() => {
		// 		resolve({ x: 0, y: 0 })
		// 	// }, 500)
		// })
		// }
	},
	routes: [
		{
			path: '/',
			name: 'home',
			component: home,
		},
		{
			path: '/privacy-policy',
			name: 'privacy',
			component: privacy,
		},
		{
			path: '/about',
			name: 'about',
			component: about,
		},
		{
			path: '/quality',
			name: 'quality',
			component: quality,
		},
		{
			path: '/fine-finish',
			name: 'fine-finish',
		},
		{
			path: '/bazis-a-corp',
			name: 'bazis-a-corp',
		},
		{
			path: '/flats',
			name: 'flats-crm',
			component: flatsCRM,
		},
		{
			path: '/flats/:id',
			name: 'flat-crm-card',
			component: flatsCRMcard,
		},
		{
			path: '/flats-viewing-history',
			name: 'flat-viewing-history-page',
			component: flatsCrmViewingHistory,
		},
		{
			path: '/news',
			name: 'news--page',
			component: news,
		},
		{
			path: '/news/:id',
			name: 'news-card',
			component: newsCard,
		},
		{
			path: '/projects',
			name: 'projects--page',
			component: projects,
		},
		{
			path: '/projects/:id',
			name: 'project-card',
			component: projectCard,
		},
		// {
		// 	path: '/actions',
		// 	name: 'actions--page',
		// 	component: actions,
		// },
		// { 
		// 	path: '/actions/:id', 
		// 	name: 'action-card', 
		// 	component: actionCard,
		// },
		{
			path: '/contacts/',
			name: 'contacts-sales',
			component: contacts,
		},
		// {
		// 	path: '/owners',
		// 	name: 'owners--page',
		// 	// component: owners,
		// },
		{
			path: '/realestate',
			name: 'realestate--page',
			redirect: {name: 'sales'},
			// component: realestate,
		},
		{ 
			path: '/sales', 
			name: 'sales', 
			component: sales,
		},
		{ 
			path: '/sales/promo/:id', 
			name: 'sales-card-promo', 
			component: salesCardPromo,
		},
		{ 
			path: '/sales-map', 
			name: 'sales-map', 
			component: SalesMap,
		},
		{
			path: '/purchase',
			name: 'purchase--page',
			// component: purchase,
			redirect: {name: 'how-to-by'},
		},
		{
			path: '/bazis-club',
			name: 'bazis-club',
			component: bazisClub,
		},
		{ 
			path: '/bazis-club/:id', 
			name: 'bazis-club-card', 
			component: bazisClubCard,
		},
		{
			path: '/how-to-by',
			name: 'how-to-by',
			component: howToBy,
		},
		{
			path: '/bazis-payment-plan',
			name: 'bazis-finance',
			component: bazisFinance,
		},
		{
			path: '/hypothec',
			name: 'hypothec',
			component: hypothec,
		},
		{
			path: '/hypothec-calculator',
			name: 'hypothec-calculator',
			component: hypothecCalculator,
		},
		{
			path: '/compare',
			name: 'compare',
			component: compare,
		},
		{
			path: '/favorite',
			name: 'favorite-page',
			redirect: {name: 'favorite-projects'},
			component: favorite,
			meta: { 
				crumbs: '/Избранное',
				path: '/favorite'
			},
			children: [
				{ 
					path: '/favorite/favorite-projects', 
					name: 'favorite-projects',
					component: favoriteProjects,
					meta: {
						crumbs: '/Избранное/Жилые комплексы',
						path: '/favorite-projects'
					}
				},
				{ 
					path: '/favorite/favorite-flats', 
					name: 'favorite-flats',
					component: favoriteFlats,
					meta: {
						crumbs: '/Избранное/Квартиры',
						path: '/favorite/favorite-flats'
					}
				},
			]
		},
		{
			path: '/video',
			name: 'video-page',
			component: video,
			meta: { 
				crumbs: '/Видео',
				path: '/Video'
			}
		},
		{
			path: '/video-safety',
			name: 'video-page-safety',
			component: video_safety,
			meta: { 
				crumbs: '/Сейсмобезопасность зданий',
				path: '/video-safety'
			}
		},
		{
			path: '/online',
			name: 'online-page',
			component: online,
			meta: { 
				crumbs: '/Приобретение/Онлайн бронирование',
				path: '/online'
			}
		},
		{
			path: '/enpf',
			name: 'enpf-page',
			component: ENPF,
			meta: { 
				crumbs: '/Приобретение/Использование пенсионных накоплений',
				path: '/enpf'
			}
		},
		{
			path: '/new-owners',
			name: 'new-owners',
			component: newOwners,
		},
		{
			path: '/commerce',
			name: 'commerce-sales',
			component: commerceSales,
		},
		{
			path: '/online-booking-details',
			name: 'online-booking-details',
			component: onlineBoocking,
		},
		{
			path: '/seismic-safety',
			name: 'seismic-safety',
			component: seismicSafety,
		},
		{
			path: '/awards',
			name: 'awards',
			component: awards,
		},
		{
			path: '/questions-answers',
			name: 'answers',
			component: answers,
		},
		{ 
            path: '/404', 
            name: '404', 
            component: NotFound, 
        }, 
        { 
            path: '*', 
            redirect: '/404'
		},
		{ 
            path: '/error', 
            name: 'error', 
            component: error, 
		},
		{
			path: '/fine-finish',
			beforeEnter() {window.open('http://fine-finish.kz', '_blank',)}
			
		}
	]
})

router.beforeResolve((to, from, next) => {
  if (to.name) {
	// console.log(to.name)
	store.commit('setPageName', to.name);
	// Счетчик избранных карточек из LocalStorage
	var items = localStorage.getItem('favorite_projects');
	items = items ? items.split(',') : [];
	store.commit('setFavoriteCount', items.length);
	// Закрываем мобильное меню
	store.commit('Open_Sendwich', false);
	document.getElementsByTagName('body')[0].classList.remove('overlay-open');
	// Конец счетчика изюранных карточек
	// if (to.meta.template != 'sale-card') {
	// 	store.commit('resetSaleCardContent', null);
	// }
  }
  if (to.name == 'bazis-club') {
	store.commit('set_view_bazis_Club_form', true);
  } else {
	store.commit('set_view_bazis_Club_form', false);
  }
  if (to.name != 'sales-app') {
	store.commit('clearSalesLandCardContent');
  } 
  
  	if (to.name == 'fine-finish') {
		// console.log('ASDASDASD')
		window.open('https://fine-finish.kz');
		next(from);
  	} else if (to.name == 'bazis-a-corp') {
		window.open('https://bazis.kz');
		next(from);
	}

  
  next()
})

// router.afterEach((to, from) => {
//   setTimeout(()=>{
// 	store.commit('breadCrumbInt', to.name);
//  },650);
// })

export default router
